// extracted by mini-css-extract-plugin
export default {"spinner_container":"Loader_spinner_container__3Jj-S","spinner":"Loader_spinner__Ealn1","spinner-d3wgkg":"Loader_spinner-d3wgkg__4HOsG"};